import { render, staticRenderFns } from "./makeUp.vue?vue&type=template&id=1ba99996&"
import script from "./makeUp.vue?vue&type=script&lang=ts&"
export * from "./makeUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports